import productCardSkeletonDesktop from './acco-tile-desktop.svg';
import productCardSkeletonMobile from './acco-tile-mobile.svg';

export { productCardSkeletonDesktop, productCardSkeletonMobile };
